import { StaffLayout } from "@/components/layouts/staff-layout"
import {
  ItemStockWorkspace,
  type ItemStockWorkspaceProps,
} from "@/features/staff/item-stock/item-stock-workspace"

export default function StaffLocationManageItemStocksIndex(props: ItemStockWorkspaceProps) {
  return (
    <StaffLayout>
      <ItemStockWorkspace {...props} />
    </StaffLayout>
  )
}
